/* eslint-disable no-unused-vars, no-useless-constructor, no-empty-function */
import { Manager } from './Manager';
import { ManagerRole } from './ManagerRole';

type ActorType = 'manager' | 'mentor' | 'member' | 'anonymous';

class ManagerCapabilities {
  constructor(
    readonly role: ManagerRole | null,
    readonly isManager: boolean,
    readonly isBridgeManager: boolean,
    readonly canBypassRestrictions: boolean,
    readonly canUseParrobot: boolean,
    readonly canViewSensitiveProfileFields: boolean,
    readonly canViewSensitiveApplicationFields: boolean,
    readonly canManageCrossOrgPrograms: boolean,
    readonly actorType: ActorType,
  ) {}

  static fromRole(role: ManagerRole | null): ManagerCapabilities {
    if (!role) {
      return new ManagerCapabilities(null, false, false, false, true, false, false, false, 'anonymous');
    }

    const isBridgeManager = role === ManagerRole.BRIDGE_STAFF;

    return new ManagerCapabilities(
      role,
      true,             // isManager
      isBridgeManager,  // isBridgeManager
      true,             // canBypassRestrictions
      false,            // canUseParrobot — managers don't use Parrobot
      true,             // canViewSensitiveProfileFields
      true,             // canViewSensitiveApplicationFields
      isBridgeManager,  // canManageCrossOrgPrograms
      'manager',
    );
  }

  static fromManager(manager: Manager | null): ManagerCapabilities {
    return ManagerCapabilities.fromRole(manager ? manager.role : null);
  }
}

export { ManagerCapabilities };
export type { ActorType };
